import { REACT_QUERY_KEYS } from '@/constants'

export const shipmentOrderHistoriesQueryKeys = {
  all: [REACT_QUERY_KEYS.SHIPMENT_ORDER_HISTORIES] as const,
  select: (tenantKey: string) =>
    [...shipmentOrderHistoriesQueryKeys.all, 'select', tenantKey] as const,
  detail: (tenantKey: string, id: number) =>
    [...shipmentOrderHistoriesQueryKeys.all, 'detail', tenantKey, id] as const
}

export const shipmentOrdersQueryKeys = {
  all: [REACT_QUERY_KEYS.SHIPMENT_ORDERS] as const,
  regularGroup: (tenantKey: string, regularGroupId: string) =>
    [
      ...shipmentOrdersQueryKeys.all,
      'regularGroup',
      tenantKey,
      regularGroupId
    ] as const,
  bundle: (tenantKey: string, bundleId: number) =>
    [...shipmentOrdersQueryKeys.all, 'bundle', tenantKey, bundleId] as const
}
